import { render, staticRenderFns } from "./AdminPageSkeleton.vue?vue&type=template&id=54116be4&scoped=true"
import script from "./AdminPageSkeleton.vue?vue&type=script&lang=js"
export * from "./AdminPageSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AdminPageSkeleton.vue?vue&type=style&index=0&id=54116be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54116be4",
  null
  
)

export default component.exports